<template>
  <div class="u-cont">
    <v-container>
        <h1>Approved Songs</h1>
        <v-row>
            <v-col cols="4" v-for="file in files" :key="file.id">
                <!-- {{file}} -->
                <Song v-bind:file="file.path" v-bind:name="file.name"/>
            </v-col>
        </v-row>
    </v-container>
      <div>
        <MusicPlayerFooter/>
      </div>
  </div>
</template>

<script>
import {db} from '../config/firebaseInit'
import Song from '../components/Song'
import MusicPlayerFooter from "../components/MusicPlayerFooter";
export default {
    name:'AppprovedSongs',
    components: {
        Song,
        MusicPlayerFooter
    },
    data: function () {
        return{
            files:[]
        }
        
    },
    created(){
        this.retrieveSongs()
    },
    methods:{
        retrieveSongs() {
            let filesArray = [];
                db.collection('submissions').get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());
                        const {fname, email, fileURL, approved} = doc.data();
                        if(approved){
                            filesArray.push({
                                id:doc.id,
                                name:fname,
                                email:email,
                                path:fileURL
                            });
                        }
                        
                    });
                });
                this.files = filesArray;
        }
    }

}
</script>

<style>

</style>